export default {
    lang: '印尼语',
    application: {
        name: 'Sistem Penerbitan Informasi',
    },
    ajaxTip: {
        success: 'Berhasil',
        error: 'Gagal',
        noAccess: 'Tidak memiliki izin mengakses sumber daya ini',
        notFound: 'Sumber daya yang diakses tidak ada',
        serverBusy: 'Server sibuk',
        timeOut: 'Waktu habis',
    },
    menu: {
        home: 'Beranda',
        template: 'Manajemen Template',
        program: 'Manajemen Program',
        playplan: 'Rencana Pemutaran',
        device: 'Manajemen Perangkat',
        "source-material": 'Manajemen Materi Sumber',
        material: 'Materi',
        checkManage: 'Manajemen Pemeriksaan',
        setting: 'Pengaturan',
        usercenter: "Pusat Pengguna",
        adminManage: "Manajemen Perangkat",
        schedule: "Tugas yang Harus Dilakukan",
        capitalassets: "Manajemen Aset",
        modifyPassword: "Ubah Kata Sandi",
        logout: "Keluar",
        "add": "Tambah",
        "edit": "Edit",
        "delete": "Hapus",
        "view": "Lihat",
        "menu_1": "Beranda",
        "menu_2": "Manajemen Perangkat",
        "menu_3": "Edit (Pengaturan Lanjutan - Edit Biasa - Ganti Jaringan)",
        "menu_4": "Perintah Instan",
        "menu_5": "Edit (Pindahkan Departemen)",
        "menu_6": "Strategi",
        "menu_7": "Pengaturan Volume",
        "menu_8": "Pengaturan Kecerahan",
        "menu_9": "Pengaturan Unduhan",
        "menu_10": "Pengaturan Tidur",
        "menu_11": "Properti Perangkat",
        "menu_12": "Edit/Tambah",
        "menu_13": "Manajemen Program",
        "menu_14": "Riwayat Publikasi",
        "menu_15": "Hapus (Batch/Individual)",
        "menu_16": "Program yang Sedang Dipublikasikan",
        "menu_17": "Pengelompokan",
        "menu_19": "Daftar Program",
        "menu_20": "Edit Konten",
        "menu_21": "Salin Program",
        "menu_23": "Publikasikan Program",
        "menu_24": "Manajemen Materi",
        "menu_25": "Unggah",
        "menu_28": "Publikasi Cepat",
        "menu_29": "Manajemen Template",
        "menu_30": "Template Umum",
        "menu_31": "Gunakan Sekarang",
        "menu_32": "Template Saya",
        "menu_33": "Publikasikan ke Template Umum",
        "menu_35": "Riwayat Berbagi",
        "menu_36": "Manajemen Audit",
        "menu_37": "Audit Program",
        "menu_38": "Audit (Setujui/Tolak)",
        "menu_39": "Audit Materi",
        "menu_41": "Riwayat Audit (Operator)",
        "menu_42": "Riwayat Audit (Auditor)",
        "menu_43": "Lihat Jumlah Persetujuan",
        "menu_44": "Manajemen Organisasi",
        "menu_45": "Manajemen Log",
        "menu_46": "Log Pemutaran",
        "menu_47": "Log Publikasi",
        "menu_48": "Log Kesalahan",
        "menu_49": "Log Operasi",
        "menu_50": "Log File",
        "menu_51": "Log Masuk",
        "menu_52": "Persetujuan Konten",
        "menu_53": "Ruang Penyimpanan",
        "menu_54": "Struktur Organisasi",
        "menu_55": "Hak Akses Peran",
        "menu_56": "Otorisasi",
        "menu_57": "Lihat (Hak Akses Otorisasi)",
        "menu_58": "Anggota Organisasi",
        "menu_60": "Atur Ulang Kata Sandi Pengguna Bawahan",
        "menu_61": "Manajemen Aset",
        "menu_62": "Saldo Saya",
        "menu_63": "Lihat (Rincian Dana)",
        "menu_64": "Data Saya",
        "menu_65": "Lihat (Rincian Data)",
        "menu_66": "Beli Data",
        "menu_67": "Kapasitas Saya",
        "menu_68": "Perangkat Saya",
        "menu_69": "Rincian Pesanan",
        "menu_70": "Lihat (Isi Ulang)",
        "menu_71": "Lihat (Template yang Dibeli)",
        "menu_72": "Lihat (Data yang Dibeli)",
        "menu_73": "Hak Akses Lainnya",
        "menu_74": "Lihat (Statistik Materi dan Program)",
        "menu_75": "Lihat (Aset)",
        "menu_76": "Lihat (Data Cloud/Statistik)",
        "menu_77": "Lihat (Statistik Perangkat Online)"
    },
    login: {
        terminalServiceSystem: 'Sistem Layanan Terminal Cerdas',
        accountLogin: 'Login Akun',
        register: 'Daftar',
        accountLoginTip: 'Login dengan akun yang sudah ada',
        scanQRCode: 'Silakan pindai kode QR',
        readAndAgree: 'Saya telah membaca dan menyetujui',
        readAndAgreeLink: 'Perjanjian Layanan Pengguna',
        readAndAgreeAgreement: 'Silakan baca dan setujui Perjanjian Layanan Pengguna',
        forgetpassword: "Lupa kata sandi?",
        resetpassword: "Atur Ulang Kata Sandi",
        phoneEmptyTip: "Silakan masukkan nomor telepon",
        nextStep: "Langkah Selanjutnya",
        title: 'Selamat Datang Login',
        submit: 'Login',
        userName: 'Akun',
        password: 'Kata Sandi',
        userNameEmptyTip: 'Silakan masukkan akun',
        passwordEmptyTip: 'Silakan masukkan kata sandi',
        passwordFormatTip: 'Silakan masukkan format kata sandi yang benar',
        passwordIsOk: 'Silakan masukkan konfirmasi kata sandi',
        passwordSign: 'Silakan masukkan kata sandi',
        codeTip: "Silakan masukkan kode verifikasi",
        phone: "Nomor telepon tidak boleh kosong",
        code: "Kode verifikasi tidak boleh kosong",
        nickname: "Nama perusahaan tidak boleh kosong",
        pass: "Kata sandi tidak boleh kosong",
        pwdMessage: "Panjang kata sandi 8~20 karakter, tidak boleh berisi spasi dan harus mengandung 3 jenis di antara huruf besar, huruf kecil, angka, dan karakter khusus",
        pwdMessage01: "Silakan masukkan kata sandi kombinasi huruf dan angka minimal delapan digit",
        pwdMessage02: "Panjang kata sandi 8-20 karakter",
        pwdMessage03: "Kata sandi tidak boleh mengandung spasi",
        pwdMessage04: "Kata sandi harus mengandung tiga di antara huruf besar, huruf kecil, angka, dan simbol",
        newpassempty: "Kata sandi baru tidak boleh kosong",
        newpass: "Dua kali input kata sandi tidak konsisten",
        getcode: "Dapatkan Kode Verifikasi",
        format: "Format nomor telepon tidak benar",
        chongfa: "Kirim ulang setelah detik",
        isSend: 'Telah dikirim',
        noregister: "Belum punya akun? Daftar sekarang",
        Mobile: "Nomor Telepon",
        verificationcode: "Kode Verifikasi",
        petname: "Nama Panggilan",
        Quickregistration: "Pendaftaran Cepat",
        xiugaimima: "Ubah Kata Sandi",
        jiumima: "Kata Sandi Lama",
        xinmima: "Kata Sandi Baru",
        zaicishuruxinmima: "Masukkan Kata Sandi Baru Kembali",
        xiugaichenggong: "Berhasil diubah",
        xiugaishoujihao: "Ubah Nomor Telepon",
        dengluzhanghao: "Akun Login",
        gongsiid: "ID Perusahaan",
        yonghunicheng: "Nama Panggilan Pengguna",
        chuangjianshijian: "Waktu Pembuatan",
        gongsimingcheng: "Nama Perusahaan",
        denglumima: "Kata Sandi Login",
        jianyi: "Disarankan menggunakan kata sandi kombinasi huruf dan angka",
        shezhimima: "Atur Kata Sandi",
        shezhishoujihao: "Ubah/Atur Nomor Telepon",
        yibangding: "Telah Terikat",
        weibangding: "Belum Terikat",
        zhanghuanquan: "Keamanan Akun",
        yonghuxinxi: "Informasi Pengguna",
        zhuceSucMsg: 'Selamat, pendaftaran berhasil!',
        verificationcodeSucMsg: "Kode verifikasi berhasil dikirim！",
        requiredIsEmpty: "Bidang wajib tidak boleh kosong！",
        emailObj: {
            title: 'Email',
            tit: 'Login Email',
            tip: 'Silakan masukkan alamat email',
            formatTip: 'Silakan masukkan format email yang benar',
        },
        phoneObj: {
            title: 'Nomor Telepon',
            tit: 'Login Telepon',
            tip: 'Silakan masukkan nomor telepon',
            formatTip: 'Silakan masukkan format nomor telepon yang benar',
        },
        emailOrPhoneObj: {
            title: 'Email atau Nomor Telepon',
            tit: 'Login Email atau Telepon',
            tip: 'Silakan masukkan email atau nomor telepon',
            formatTip: 'Silakan masukkan format email atau nomor telepon yang benar',
        },
        wechatObj: {
            title: 'WeChat',
            tit: 'Login WeChat',
        },
        googleObj: {
            title: 'Google',
            tit: 'Login Google',
        },
        confirm: 'Ya',
        confirmSubmit: 'Kirim Konfirmasi',
        cancel: 'Batal',
        close: 'Tutup',
        bindSucMsg: 'Berhasil terikat',
        toContinueBindAccount: 'Lanjutkan untuk menyelesaikan pengikatan akun pihak ketiga',
        bindTip01: 'Tidak punya akun? Daftar satu',
        bindTip02: 'Sudah punya akun',
        bindTip03: 'Akun pihak ketiga saat ini belum terikat dengan akun platform, silakan ikat akun yang sudah ada atau daftarkan dan ikat akun baru, sehingga dapat login cepat di lain waktu.',
        bindTip04: 'Ikat akun yang sudah ada',
        bindTip05: 'Daftar dan ikat akun baru',
        bindTip06: 'Anda telah berwenang melalui pihak ketiga, lengkapi informasi login di bawah ini untuk menyelesaikan pengikatan',
        bindSubmit: 'Kirim Pengikatan',
        enterAccountTip: 'Silakan masukkan nama akun',
        RegisterAndBind: 'Daftar dan Ikat',
        loginErr: 'Nama pengguna atau kata sandi salah！',
        usercenter: "Pusat Pengguna",
        pleaseInputName: "Silakan masukkan nama",
        operationSuccess: "Operasi berhasil！",
        edit: "Edit",
        xiugai: "Ubah",
        userData: "Data Pribadi",
        changePassword: "Ubah Kata Sandi",
        account: "Akun",
        userName01: "Nama Pengguna",
        phoneNumber: "Nomor Telepon",
        role: "Peran",
        createTime: "Waktu Pembuatan",
        genghuang: "Ganti",
        bangding: "Ikat",
        unbind: "Lepas Ikat",
        plesaseSelectBindingType: "Silakan pilih jenis pengikatan",
        pleaseConfirmCont: "Silakan konfirmasi bahwa saya telah membaca konten ini",
        confirmReadCont: "Saya telah membaca konten ini",
        frequentTip: "Operasi terlalu sering, silakan coba lagi nanti!",
        zhuxiaoBtn: "Hapus Akun",
        zhuxiaoTitle: "Penghapusan Akun",
        querenZhuxiao: "Yakin Hapus",
        jiXu: "Lanjutkan",
        sendCodeBtn: "Kirim Kode Verifikasi",
        passwordIsNotOldPassword: "Konfirmasi kata sandi berbeda dengan kata sandi baru yang dimasukkan",
        passwordIsOldPassword: "Kata sandi yang diubah sama dengan kata sandi lama",
        passFormatError: "Silakan masukkan format kata sandi yang benar",
        oldPassWord: "Kata Sandi Lama",
        newPassWord: "Kata Sandi Baru",
        inputPlaceholder: 'Silakan masukkan',
        confirmPassword: "Konfirmasi Kata Sandi",
        zhuxiaoTip: `
            1、Penghapusan akun adalah operasi yang tidak dapat dipulihkan, setelah akun dihapus, Anda tidak dapat lagi login dan menggunakan akun ini atau akun pihak ketiga yang didaftarkan dan login melalui akun ini, silakan backup informasi dan data terkait akun secara mandiri.
            2、Sebelum mendaftar akun ini, pastikan Anda telah mengosongkan semua aset dan tidak ada perselisihan apapun; setelah akun ini dihapus, dianggap bahwa Anda melepaskan hak milik atas semua aset dan hak di dalam akun ini, dan tidak dapat dipulihkan atau ditemukan kembali.
            3、Jika akun yang didaftarkan dengan nomor telepon yang sama dihapus hingga 3 kali secara kumulatif, nomor telepon tersebut tidak dapat mendaftar akun baru lagi, dan juga tidak dapat diikat ke akun lain apapun.
            `
    },
    home: {
        title: "Beranda",
        quickOperation: "Operasi Cepat",
        addDevice: "Tambah Perangkat",
        publishProgram: "Terbitkan Program",
        publishMaterial: "Terbitkan Materi",
        makeProgram: "Buat Program",
        uploadMaterial: "Unggah Materi",
        todayData: "Data Hari Ini (Diperbarui Setiap Jam)",
        playNumChart: "Statistik Jumlah Pemutaran",
        deviceOnlineStatus: "Status Online Perangkat",
        onLineDevice: "Perangkat Online",
        unLineDevice: "Perangkat Offline",
        programPlayTime: "Statistik Durasi Pemutaran Program",
        downloadSoft: "Unduh Perangkat Lunak",
        adminApp: "Aplikasi Pengguna Mobile",
        playerApp: "Terminal Pemutaran Penerbitan Informasi",
        downloadAdminApp: "Klik untuk mengunduh aplikasi pengguna",
        downloadPlayerApp: "Klik untuk mengunduh aplikasi pemutar",
        aboutUs: "Tentang Kami",
        userManual: "Panduan Pengguna",
        message: "Saya Ingin Beri Pesan",
    },
    device: {
        inputPlaceholder: 'Silakan masukkan',
        selectPlaceholder: 'Silakan pilih',
        osTypeStr: 'Sistem Terminal',
        onLineStatus: 'Status Online',
        dpi: 'Resolusi',
        companyDeptIdName: 'Instansi Terkait',
        deviceGroupIdName: 'Grup Terkait',
        editOrMove: 'Edit/Pindahkan',
        loanOriginationFee: 'Biaya Administrasi Pinjaman',
        strategyInfoLook: 'Lihat Informasi Strategi',
        programLook: 'Lihat Program',
        addEquipments: 'Tambah Perangkat',
        luminanceSet: 'Kontrol Kecerahan',
        terminal: 'Pengaturan Terminal',
        transferCompany: 'Pindahkan Departemen',
        releasedProgram: 'Terbitkan Program',
        screenshot: 'Tangkapan Layar',
        changeGroup: 'Ubah Grup',
        defaultGroup: "Grup Default",
        operation: "Operasi",
        edit: "Edit",
        saveEdit: "Simpan Edit",
        add: "Tambah",
        save: "Simpan",
        setting: "Pengaturan",
        program: "Program",
        unbind: "Lepas Ikat",
        sleep: "Mode Tidur",
        wakeup: "Bangunkan",
        restart: "Restart",
        shutdown: "Matikan",
        reportLog: "Laporkan Log",
        clearPlayData: "Hapus Data Terminal Pemutaran",
        offlineWarn: "Perangkat ini sudah offline, silakan coba lagi setelah perangkat online！",
        confirmUnbind: "Yakin untuk melepaskan ikatan",
        confirmReset: "Yakin untuk menghapus",
        confirmDelete: "Yakin untuk menghapus",
        delete: "Hapus",
        cancelDelete: "Batal Hapus",
        confirmResetSuccess: "Berhasil dihapus",
        confirm: "Ya",
        cancel: "Batal",
        operationSuccess: "Operasi Berhasil",
        unbindSuccess: "Berhasil Melepas Ikat",
        pleaseSelectDevice: "Silakan pilih perangkat",
        pleaseSelectOnlineDevice: "Silakan pilih perangkat online",
        confirmMixOperation: "Perangkat yang dipilih termasuk perangkat offline, pengaturan ini tidak berlaku untuk perangkat offline, yakin melanjutkan operasi？",
        pleaseSelectDate: "Silakan pilih tanggal",
        reportSuccess: "Berhasil melaporkan",
        deviceSetting: "Pengaturan Perangkat",
        default: "Default",
        all: "Semua",
        deviceList: "Daftar Perangkat",
        addDevice: "Tambah Perangkat",
        department: "Departemen Instansi",
        deviceType: "Resolusi",
        osType: "Sistem Terminal",
        onlineState: "Status Online",
        online: "Online",
        offline: "Offline",
        notActive: "Belum Diaktifkan",
        search: "Silakan masukkan kata kunci",
        batchOperation: "Operasi Batch",
        allDevices: "Semua Perangkat",
        deviceAttribute: "Atribut Perangkat",
        selectReportDate: "Pilih Tanggal Pelaporan",
        inputName: "Silakan masukkan nama",
        inputWidth: "Silakan masukkan lebar",
        inputHeight: "Silakan masukkan tinggi",
        inputResolutionRatio: "Silakan masukkan bilangan bulat lebih besar dari 0！",
        inputSort: "Silakan masukkan urutan",
        serialNum: "Nomor Urut",
        name: "Nama",
        width: "Lebar",
        height: "Tinggi",
        resolutionRatio: "Resolusi",
        inputResolutionRatioName: "Silakan masukkan nama resolusi",
        sort: "Urutkan",
        personal: "Pribadi",
        system: "Sistem",
        type: "Tipe",
        systemDefaultSettingUneditable: "Pengaturan default sistem tidak dapat diedit!",
        systemDefaultSettingUnDeletable: "Pengaturan default sistem tidak dapat dihapus!",
        newz: "Tambah Baru",
        total: "Total",
        totalNum: "baris",
        strategyName: "Nama Strategi",
        associatedTerminalNum: "Jumlah Terminal Terkait",
        createTime: "Waktu Pembuatan",
        pleaseSelectStrategy: "Silakan pilih strategi！",
        onlySelectOneData: "Hanya dapat memilih satu data！",
        downloadStrategy: "Unduh Strategi",
        inputStrategyName: "Silakan masukkan nama strategi",
        luminanceControl: "Kontrol Kecerahan",
        volumeStrategy: "Strategi Volume",
        saveSuccess: "Berhasil Disimpan",
        screenAngle: "Rotasi Layar(°)",
        startTime: "Waktu Mulai",
        endTime: "Waktu Akhir",
        repeat: "Ulangi",
        monday: "Senin",
        tuesday: "Selasa",
        wednesday: "Rabu",
        thursday: "Kamis",
        friday: "Jumat",
        saturday: "Sabtu",
        sunday: "Minggu",
        everyday: "Setiap Hari",
        downloadSpeed: "Kecepatan Unduhan",
        inputDownloadSpeed: "Silakan masukkan kecepatan unduhan",
        operator: "Operasi",
        pleaseSelectDeleteData: "Silakan pilih data yang akan dihapus！",
        confirmBatchDelete: "Yakin menghapus secara batch？",
        pleaseInputName: "Silakan masukkan nama",
        detailSetting: "Pengaturan Detail",
        weekPlan: "Rencana Mingguan",
        specialDateSetting: "Pengaturan Tanggal Khusus",
        weekdayInfo: "Hari dalam minggu adalah pilihan wajib!",
        volumeInfo: "Volume adalah pilihan wajib!",
        timeError: "Kesalahan pemilihan waktu!",
        editSuccess: "Operasi edit berhasil！",
        addSuccess: "Operasi tambah berhasil！",
        addSpecialPlan: "Tambah Rencana Strategi Khusus",
        downloadSpeedInfo: "Kecepatan unduhan:(0 berarti melarang unduhan)",
        pleaseSelectStartTime: "Silakan pilih waktu mulai",
        pleaseSelectEndTime: "Silakan pilih waktu akhir",
        luminanceError: "Silakan masukkan nilai kecerahan yang benar！",
        defaultLuminance: "Kecerahan Default",
        luminance: "Ukuran Kecerahan",
        defaultLuminanceInfo: "Kecerahan default(100 berarti paling terang,0 berarti paling gelap)",
        volume: "Volume",
        saveLuminance: "Simpan Kecerahan",
        changeSuccess: "Berhasil diubah！",
        changeNetwork: "Ganti Jaringan",
        netName: "Nama Jaringan",
        nameempty: "Nama jaringan tidak boleh kosong",
        currentNetwork: "Jaringan Saat Ini",
        ipAddress: "Alamat IP",
        dailyMode: "Mode Setiap Hari",
        weeklyMode: "Mode Mingguan",
        turnOnTime: "Waktu Hidupkan",
        turnOffTime: "Waktu Matikan",
        startSleep: "Mulai Mode Tidur",
        endSleep: "Akhiri Mode Tidur",
        batchDelInfo: "Yakin menghapus item yang dipilih？",
        timeCannotBeEmpty: "Waktu tidak boleh kosong!",
        startUp: "Hidupkan",
        shutDown: "Matikan",
        volumeSize: "Ukuran Volume",
        defaultVolume: "Volume Default(100 berarti maksimal,0 berarti bisu)",
        chooseStartTime: "Silakan pilih waktu mulai",
        chooseEndTime: "Silakan pilih waktu akhir",
        saveVolume: "Simpan Volume",
        screenRotationUnSaved: "Rotasi layar belum disimpan",
        volumeSettingUnSaved: "Pengaturan volume belum disimpan",
        luminanceSettingUnSaved: "Pengaturan kecerahan belum disimpan",
        confirmClosePopup: "Yakin menutup popup ini?",
        volumeSettingSuccess: "Berhasil mengubah volume",
        luminanceSettingSuccess: "Berhasil mengubah kecerahan",
        advancedSettingUnSaved: "Pengaturan lanjutan belum disimpan",
        settingTitle: "Pengaturan Terminal",
        volumeSetting: "Pengaturan Volume",
        luminanceSetting: "Pengaturan Kecerahan",
        downloadSetting: "Pengaturan Unduhan",
        sleepSetting: "Pengaturan Mode Tidur",
        onOffSetting: "Pengaturan Hidup/Mati Terjadwal",
        screenRotation: "Rotasi Layar",
        namingError: "Kesalahan penamaan, nama file tidak boleh mengandung spasi！",
        deleteSuccess: "Berhasil dihapus",
        deleteFolder: "Hapus Folder",
        pleaseInputDeviceName: "Silakan masukkan nama perangkat",
        pleaseInputDeviceId: "Silakan masukkan ID perangkat",
        discoverDevice: "Temukan Perangkat",
        deviceId: "ID Perangkat",
        bound: "Telah Terikat",
        bind: "Ikat",
        noDevice: "Tidak ada perangkat",
        refresh: "Segarkan",
        manualAdd: "Tambah Manual",
        deviceGroup: "Klasifikasi Perangkat",
        pleaseSelectGroup: "Silakan pilih grup！",
        deviceName: "Nama Perangkat",
        goAdd: "Pergi untuk menambah",
        close: "Tutup",
        bindCountInsufficient: "Jumlah yang dapat diikat tidak cukup, silakan tingkatkan jumlah perangkat sebelum menambah！",
        displayNumber: "Nomor Tampilan",
        groupName: "Nama Grup",
        pleaseSelectGroupName: "Silakan isi nama grup！",
        moveGroup: "Pindahkan Grup",
        longitude: "Bujur",
        latitude: "Lintang",
        nationality: "Kebangsaan",
        province: "Provinsi",
        city: "Kota",
        county: "Kabupaten",
        outNetIp: "IP Jaringan Luar",
        inNetIp: "IP Jaringan Dalam",
        companyName: "Nama Perusahaan",
        Info: "Detail",
        android: "Android",
        win: "Windows",
        osVersion: "Versi Sistem",
        softwareVersion: "Versi Perangkat Lunak",
        diskSize: "Ukuran Disk",
        useSize: "Ukuran Terpakai",
        macAddr: "Alamat MAC",
        longitudeLatitudeInfo: "Bujur dan lintang harus kosong atau tidak kosong secara bersamaan!",
        terminalName: "Nama Terminal",
        terminalGroup: "Grup Terminal",
        reportJournal: "Apakah melaporkan",
        systemVersion: "Versi Sistem",
        storageSpace: "Ruang Penyimpanan",
        resolution: "Resolusi",
        runningMemory: "Memori Aktif",
        model: "Model",
        registerStatus: "Status Pendaftaran",
        password: "Kata Sandi",
        passwordInfo: "Silakan masukkan 6 hingga 18 huruf atau angka!",
        group: "Grup",
        address: "Alamat",
        remark: "Catatan",
        renewalPeriod: "Periode Perpanjangan",
        money: "Biaya",
        latitudeInfo: "Silakan masukkan lintang yang benar!",
        totalPayment: "Total Jumlah Uang",
        longitudeInfo: "Silakan masukkan bujur yang benar!",
        setMeal: "Paket",
        number: "Jumlah",
        programName: "Nama Program",
        playStatus: "Status Pemutaran",
        playType: "Cara Pemutaran",
        play: "Putar",
        pause: "Jeda",
        playTime: "Waktu Pemutaran",
        programDeleted: "Program telah dihapus",
        playSuccess: "Program telah diatur untuk diputar",
        pauseSuccess: "Berhasil dijeda",
        playCycle: "Putar Berulang",
        playInsert: "Sisip Pemutaran",
        withdrawSuccess: "Berhasil ditarik kembali",
        withdrawInfo: "Silakan pilih program yang akan ditarik kembali terlebih dahulu！",
        programBelong: "Program Terkait",
        checkAll: "Pilih Semua",
        batchDel: "Hapus Secara Batch",
        delConfirm: "Yakin menghapus item yang dipilih？",
        check: "Dipilih",
        noProgram: "Tidak ada program",
        details: "Detail",
        screenshotFail: "Gagal mengambil tangkapan layar",
        policyName: "Nama Kebijakan",
        terminalNum: "Jumlah Terminal Terkait",
        powerStrategy: "Strategi Daya",
        pleaseSelectDepartment: "Silakan pilih departemen！",
        screenshotControl: "Kontrol Tangkapan Layar",
        未激活: "Belum Diaktifkan",
        已激活: "Sudah Diaktifkan",
        未绑定: "Belum Terikat",
        已绑定: "Sudah Terikat",
    },
    programManage: {
        programList: "Daftar Program",
        publishProgram: "Jejak Penerbitan Program",
        week1: "Senin",
        week2: "Selasa",
        week3: "Rabu",
        week4: "Kamis",
        week5: "Jumat",
        week6: "Sabtu",
        week7: "Minggu",
        monday: "Hari Senin",
        tuesday: "Hari Selasa",
        wednesday: "Hari Rabu",
        thursday: "Hari Kamis",
        friday: "Hari Jumat",
        saturday: "Hari Sabtu",
        sunday: "Hari Minggu",
        name: "Nama",
        preview: "Pratinjau",
        playDeviceNum: "Jumlah Perangkat Pemutar",
        copyDeviceCode: "Klik untuk menyalin",
        osType: "Tipe Sistem",
        playDate: "Tanggal Pemutaran",
        playWeek: "Minggu Pemutaran",
        everyday: "Setiap Hari",
        start: "Mulai",
        end: "Berakhir",
        playOperateStatusStr: "Status Penerbitan",
        playDevice: "Perangkat Pemutar",
        downloadView: "Lihat Unduhan",
        publisher: "Penerbit",
        publishTime: "Waktu Penerbitan",
        operation: "Operasi",
        add: "Tambah",
        groupName: "Nama Grup",
        selectDevice: "Pilih Terminal",
        searchDevice: "Cari Terminal",
        pleaseFillGroupName: "Silakan isi nama grup！",
        remarkInfo: "Catatan",
        compile: "Edit",
        withdrawConfirm: "Yakin menarik kembali program ini？",
        confirm: "Ya",
        cancel: "Batal",
        withdraw: "Tarik Kembali",
        batchWithdraw: "Tarik Kembali Secara Batch",
        batchPublish: "Terbitkan Secara Batch",
        batchDelete: "Hapus Secara Batch",
        batchOperation: "Operasi Batch",
        notUse: "Belum Digunakan",
        notChecked: "Belum Diverifikasi",
        notPass: "Tidak Diterima",
        delete: "Hapus",
        publishTextLeft: "Telah Diterbitkan",
        offTextLeft: "Telah Dijeda",
        pleaseSelectProgramToMove: "Silakan pilih program yang akan dipindahkan！",
        pause: "Jeda",
        pauseConfirm: "Yakin untuk menjeda？",
        play: "Putar",
        downloadUdisk: "Unduh ke USB",
        deviceList: "Daftar Perangkat",
        groupSelection: "Pemilihan Grup",
        operationSuccess: "Operasi Berhasil",
        deleteSuccess: "Berhasil Dihapus",
        selectDate: "Pilih Tanggal",
        publishStatus: "Status Penerbitan",
        checkStatus: "Status Verifikasi",
        waitAuditing: "Menunggu Verifikasi",
        auditPass: "Verifikasi Diterima",
        auditRefuse: "Verifikasi Ditolak",
        all: "Semua",
        playStatus: "Sedang Diputar",
        playStatust: "Status Pemutaran",
        pauseStatus: "Telah Dijeda",
        notStartStatus: "Belum Dimulai",
        resolutionratio: "Resolusi",
        totalNum: "baris",
        programName: "Nama Program",
        playStartTime: "Waktu Mulai Pemutaran",
        playEndTime: "Waktu Akhir Pemutaran",
        createTime: "Waktu Pembuatan",
        nationality: "Kebangsaan",
        province: "Provinsi",
        city: "Kota",
        county: "Kabupaten/Kecamatan",
        address: "Alamat",
        ip: "Alamat IP",
        location: "Lokasi",
        log: "Log",
        pleaseFillProgramName: "Silakan isi nama program！",
        selectGroup: "Pilih Grup",
        startTime: "Waktu Mulai",
        endTime: "Waktu Akhir",
        publishCycle: "Siklus Penerbitan",
        publishDeviceNum: "Jumlah Perangkat Penerbitan",
        pleaseSelectRecord: "Silakan pilih catatan",
        deviceName: "Nama Terminal",
        deviceId: "ID Perangkat Terminal",
        deviceGroupIdName: "Grup Tempat Terletak",
        notClassified: "Belum Klasifikasi",
        osTypeStr: "Sistem Terminal",
        storageSpace: "Ruang Penyimpanan",
        onLineStatus: "Status Online",
        onLine: "Online",
        offLine: "Offline",
        sleep: "Mode Tidur",
        unknown: "Tidak Diketahui",
        registerStatus: "Status Pendaftaran",
        trialPeriod: "Masa Uji Coba",
        notActive: "Belum Diaktifkan",
        active: "Sudah Diaktifkan",
        parameterError: "Parameter Salah!",
        pleaseSelectProgram: "Silakan pilih program!",
        pleaseSelectProgramEdit: "Silakan pilih program yang akan diedit!",
        confirmWithdrawSelectedProgram: "Yakin menarik kembali program yang dipilih？",
        withdrawSuccess: "Berhasil Ditarik Kembali",
        allPrograms: "Semua Program",
        defaultGroup: "Grup Default",
        cannotShareEmptyProgram: "Tidak dapat membagikan program kosong！",
        onlyShareYourProgram: "Hanya dapat membagikan program yang Anda buat!",
        pleaseSelectProgramEditPublishTime: "Silakan pilih program yang telah diedit waktu penerbitannya!",
        pleaseSelectDevice: "Silakan pilih perangkat!",
        programDetail: "Detail Program",
        errorReason: "Alasan Kesalahan",
        availableStorageSpaceInsufficient: "Ruang penyimpanan yang tersedia tidak cukup",
        partialDeviceReleaseFailure: "Penerbitan sebagian perangkat gagal",
        allDeviceReleaseSuccess: "Penerbitan semua perangkat berhasil",
        partialDeviceReleaseSuccess: "Penerbitan sebagian perangkat berhasil",
        allGroup: "Semua Grup",
        allProgram: "Semua Program",
        unGrouped: "Belum Berkelompok",
        replaceProgram: "Ganti Program",
        replaceProgramTip: "Program yang baru diterbitkan akan menggantikan data program yang telah dikirim ke terminal pemutar sebelumnya！",
        screen: "Layar Tunggal/Ganda",
        singleScreen: "Layar Tunggal",
        doubleScreen: "Layar Ganda",
        playSetting: "Pengaturan Pemutaran",
        batchPlaySetting: "Atur Waktu Pemutaran Secara Batch",
        individualPlaySetting: "Atur Waktu Pemutaran Secara Individual",
        playTime: "Waktu Pemutaran",
        daily: "Setiap Hari",
        weekdays: "Senin hingga Jumat",
        monthly: "Bulan Ini",
        advancedSetting: "Pengaturan Lanjutan",
        playProgram: "Putar Program",
        searchProgram: "Silakan masukkan kata kunci",
        shareAddressNotExist: "Alamat tautan tidak ada, silakan coba lagi",
        copySuccess: "Berhasil Disalin",
        shareLink: "Tautan Berbagi",
        publish: "Terbitkan",
        noResource: "Tidak Ada Sumber Daya",
        single: "Layar Tunggal",
        double: "Layar Ganda",
        time: "Waktu",
        associatedTerminalNum: "Jumlah Terminal Terkait",
        default: "Default",
        moveGroup: "Pindahkan Grup",
        pleaseSelectGroup: "Silakan isi nama grup！",
        copy: "Salin",
        FUBEN: "Salinan",
        nameempty: "Nama tidak boleh kosong",
        whitespace: "Kesalahan penamaan, nama file tidak boleh mengandung spasi！",
        programWhitespace: "Kesalahan penamaan, nama program tidak boleh mengandung spasi！",
        pleaseSelectResolution: "Silakan pilih resolusi！",
        dataError: "Data Salah！",
        createProgram: "Buat Program Baru",
        directCreate: "Buat Langsung",
        myTemplate: "Template Saya",
        use: "Gunakan",
        free: "Gratis",
        loadMore: "Muat Lebih Banyak",
        confirmDelete: "Yakin Menghapus",
        deleteGroup: "Hapus Grup",
        notPublished: "Belum Diterbitkan",
        notPassed: "Tidak Diterima",
        notUsed: "Belum Digunakan",
        confirmDeleteSelectedProgram: "Yakin menghapus program yang dipilih？",
        companyName: "Nama Perusahaan",
        programCannotDownload: "Program ini tidak dapat diunduh！",
        publishMaterial: "Terbitkan Materi",
        playMaterial: "Putar Materi",
        pleaseInputMaterialName: "Silakan masukkan nama materi",
        size: "Ukuran",
        pleaseInputDeviceName: "Silakan masukkan nama perangkat",
        item: "baris",
        allMaterial: "Semua Materi",
        allDevices: "Semua Perangkat",
        "saveSuccess": "Berhasil disimpan",
        "savefaill": "Gagal disimpan",
        "playMode": "Mode pemutaran",
        "cyclePlay": "Pemutaran siklik",
        "insertPlay": "Pemutaran sisipan",
        "noData": "Tidak ada data",
        "Add": "Tambah",
        "replace": "Ganti",
        "repeat": "Ulangi",
        "start01": "Mulai",
        "end01": "Selesai",
        "startDate": "Tanggal mulai",
        "endDate": "Tanggal selesai",
        "useNow": "Gunakan segera",
        "fillStartEndTimeFirst": "Harap isi waktu mulai dan selesai terlebih dahulu sebelum menambahkan",
        "fillFullPlayTime": "Harap isi durasi pemutaran lengkap",
        "fillCorrectPlayTime": "Harap isi periode pemutaran yang benar",
        "sDateAndEDateBothEmptyOrFilled": "Tanggal mulai dan tanggal selesai harus keduanya kosong atau keduanya terisi"
    },
    source: {
        addResource: "Tambah Sumber Daya",
        width: "Lebar",
        height: "Tinggi",
        size: "Ukuran(KB)",
        name: "Nama",
        pleaseInputResourceName: "Silakan masukkan nama sumber daya！",
        addToGroup: "Tambahkan ke Grup",
        remark: "Catatan",
        promptFgIllustrate: "Ilustrasi",
        promptFgRealisticPhoto: "Foto Realistis",
        promptFgSimplisticDrawing: "Gambar Sederhana",
        promptFgChineseStyle: "Gaya Tiongkok",
        promptFgPixelArt: "Seniman Piksel",
        noModel: "Tidak ada model, silakan hubungi administrator！",
        getModelFailed: "Gagal mendapatkan model, silakan coba lagi nanti！Atau hubungi administrator！",
        createImagePrompt: "Sedang membuat gambar, silakan tutup nanti！",
        promptEmpty: "Silakan masukkan kata petunjuk",
        dpiEmpty: "Silakan pilih rasio gambar！",
        fgEmpty: "Silakan pilih gaya！",
        style: "Gaya",
        idEmpty: "ID gambar tidak boleh kosong",
        exist: "Gambar ini sudah ada di materi",
        addSuccess: "Berhasil menambahkan materi",
        saveError: "Gagal menyimpan gambar, silakan coba lagi nanti！",
        delSuccess: "Berhasil dihapus",
        generateImage: "Teks ke Gambar",
        generateImagePlaceholder: 'Silakan masukkan gambar yang ingin Anda buat, misalnya: Seekor kupu-kupu menari di tengah lautan bunga',
        aiExpand: "Perluasan Cerdas AI",
        negativePrompt: "Petunjuk Negatif",
        negativePromptTooltip: "Digunakan untuk secara eksplisit mengecualikan konten atau fitur yang tidak ingin muncul dalam output pengguna",
        imageRatio: "Rasio Gambar",
        generateImageBtn: "Buat Sekarang",
        shengchengjieguo: "Hasil Pembuatan",
        generateImageLoadingTip: "Sedang dibuat, jangan klik ulang atau tutup...",
        Tooltip: "Ayo wujudkan kreativitas Anda dengan AI",
        saveToMaterial: "Simpan ke Materi",
        publish: "Terbitkan Sekarang",
        download: "Unduh",
        generateHistory: "Riwayat Pembuatan",
        hide: "Sembunyikan",
        cancel: "Batal",
        useExpand: "Gunakan Perluasan",
        all: "Semua",
        delete: "Hapus",
        loadMore: "Muat Lebih Banyak",
        aiTip: "Konten dibuat oleh model kecerdasan buatan, tidak mewakili pandangan, posisi atau sikap platform, silakan gunakan konten AI dengan wajar dan sesuai peraturan",
        operationSuccess: "Operasi Berhasil",
        moveGroup: "Pindahkan Grup",
        groupName: "Nama Grup",
        pleaseSelectGroup: "Silakan pilih nama grup！",
        shenhe: "Verifikasi",
        shenheStatus: "Status Verifikasi",
        shenheSuccess: "Verifikasi Diterima",
        shenheRefuse: "Verifikasi Ditolak",
        pleaseSelectShenheStatus: "Silakan pilih status verifikasi！",
        shenheRemark: "Catatan Verifikasi",
        pleaseInputShenheRemark: "Silakan masukkan catatan verifikasi！",
        pleaseInputFileName: "Silakan masukkan nama file！",
        whitespace: "Kesalahan penamaan, nama file tidak boleh mengandung spasi！",
        dataError: "Data Salah！",
        confirmDelete: "Yakin Menghapus",
        confirm: "Ya",
        deleteFolder: "Hapus Folder",
        add: "Tambah",
        edit: "Edit",
        fileName: "Nama File",
        group: "Grup",
        resolution: "Resolusi",
        type: "Tipe",
        image: "Gambar",
        music: "Musik",
        video: "Video",
        uploadTime: "Waktu Unggah",
        uploadUser: "Pengunggah",
        checkTime: "Waktu Verifikasi",
        checkUser: "Pemeriksa",
    },
    setting: {
        nameempty: "Nama tidak boleh kosong",
        heightempty: "Tinggi tidak boleh kosong",
        widthempty: "Lebar tidak boleh kosong",
        resolutionratio: "Resolusi",
        name: "Nama",
        opteration: "Operasi",
        compile: "Edit",
        delete: "Hapus",
        newz: "Tambah Baru",
        compileratio: "Edit Resolusi",
        sheizhifenbianlvmingcheng: "Atur Nama Resolusi",
        shezhigaodu: "Atur Tinggi",
        shezhikuandu: "Atur Lebar",
        xinzengfenbianlv: "Tambah Resolusi Baru",
        bianma: "Kode",
        bianjizhongduanmingcheng: "Edit Nama Terminal",
        xinzengzhongduan: "Tambah Terminal Baru",
        selectPrimaryColor: 'Pilih Warna Tema',
        fullScreen: 'Layar Penuh',
        exitFullScreen: 'Keluar dari Layar Penuh',
    },
    tabs: {
        refresh: 'Segarkan',
        refreshAll: 'Segarkan Semua',
        close: 'Tutup',
        closeOthers: 'Tutup Lainnya',
        closeAll: 'Tutup Semua',
        closeLeft: 'Tutup Kiri',
        closeRight: 'Tutup Kanan',
    },
    errorPage: {
        needLogin: 'Anda belum login！',
        pageNotFound: 'Halaman yang Anda akses tidak ada！',
        redirectTo: 'Alihkan ke',
        orReturn: 'Atau kembali ke',
        previousStep: 'Langkah Sebelumnya',
    },
    headerUs: {
        systemNotice: "Pemberitahuan Sistem",
        allNotices: "Semua Pemberitahuan",
        viewAllMessages: "Lihat Semua Pesan",
        contactUs: "Hubungi Kami",
        operationSuccess: "Operasi Berhasil！",
        leaveMessage: "Saya Ingin Beri Pesan",
        messageTitle: "Judul",
        messageTitleTip: "Silakan masukkan judul！",
        messageContentTip: "Maksimal 150 kata",
        submit: "Kirim",
        markAsRead: "Tandai sebagai Dibaca",
        success: "Operasi Berhasil！"
    },
    material: {
        allMaterial: "Semua Materi",
        defaultGroup: "Grup Default",
        auditStatus: "Status Verifikasi",
        auditPassed: "Verifikasi Diterima",
        auditRejected: "Verifikasi Ditolak",
        pendingAudit: "Menunggu Verifikasi",
        all: "Semua",
        operateSuccess: "Operasi Berhasil！",
        pleaseSelectMaterial: "Silakan pilih materi！",
        moveGroup: "Pindahkan Grup",
        pleaseSelectGroup: "Silakan pilih grup！",
        batchPublish: "Terbitkan Secara Batch",
        batchRecall: "Tarik Kembali Secara Batch",
        batchDelete: "Hapus Secara Batch",
        materialList: "Daftar Materi",
        uploadMaterial: "Unggah Materi",
        materialType: "Tipe Materi",
        pleaseInputMaterialName: "Silakan masukkan nama materi",
        selectAll: "Pilih Semua",
        confirmDeleteSelectedMaterial: "Yakin menghapus materi yang dipilih？",
        deleteSuccess: "Berhasil Dihapus",
        delete: "Hapus",
        publish: "Terbitkan",
        recall: "Tarik Kembali",
        confirmRecallSelectedMaterial: "Yakin menarik kembali materi yang dipilih？",
        pleaseSelectMaterialGroup: "Silakan pilih grup materi！",
        recallSuccess: "Berhasil Ditarik Kembali",
        publishSuccess: "Berhasil Diterbitkan",
        batchOperate: "Operasi Batch",
        item: "baris",
        confirmDelete: "Yakin Menghapus？",
        edit: "Edit",
        confirmRecall: "Yakin Tarik Kembali？",
        unaudited: "Belum Diverifikasi",
        notPassed: "Tidak Diterima",
        operate: "Operasi",
        resolution: "Resolusi",
        none: "Tidak Ada",
        confirm: 'Ya',
        cancel: 'Batal',
        AICreation: "Kreasi AI",
    },
    uploadFile: {
        operationSuccess: "Operasi Berhasil",
        uploadFile: "Manajemen Unggah",
        uploadSuccess: "Berhasil Unggah",
        uploadCompleted: "Unggah Selesai",
        uploadFail: "Gagal Unggah",
        ConversionFailed: "Konversi Gagal！",
        loading: "Sedang memuat...",
        beQueuing: "Dalam Antrean...",
        Uploading: "Mengunggah...",
        ConversionIng: "Mengkonversi...",
        ConventionalResources: "Sumber Daya Konvensional",
        DocumentResources: "Sumber Daya Dokumen",
        complete: "Selesai",
        upload: "Unggah",
        fileSizeWraning01: "Ukuran materi melebihi",
        fileSizeWraning02: "Silakan modifikasi dan unggah ulang！",
        fileIsEmpty: "File kosong",
        uploadFileTip: "Format file tidak didukung",
        unablePreview: "Tidak berhasil ditambahkan ke perpustakaan materi, tidak dapat dipratinjau",
        confirmDelete: "Yakin Menghapus？",
        deleteSuccess: "Berhasil Dihapus",
        delete: "Hapus",
        confirm: "Ya",
        preview: "Pratinjau",
        close: "Tutup",
        cancel: "Batal",
        fileType: "Tipe File",
        fileSize: "Ukuran File",
        conversionProgress: "Progres Konversi",
        progress: "Progres",
        image: "Gambar",
        video: "Video",
        audio: "Musik",
        limitTip01: "Unggah sekaligus",
        limitTip02: "file",
        okTip: "Sedang mengunggah materi, silakan tutup nanti！",
        usableSize: 'Kapasitas Tersedia',
        sizeUnableTip: "Ruang penyimpanan yang tersedia saat ini tidak cukup, silakan bersihkan materi yang tidak berguna secara teratur untuk menghemat ruang atau hubungi distributor untuk memperluas kapasitas ruang penyimpanan cloud. Layanan ini mungkin menimbulkan biaya, silakan merujuk pada informasi distributor untuk detailnya.",
        view: "Lihat Detail",
        fileName: "Nama File",
    },
    template: {
        inputPlaceholder: 'Silakan masukkan',
        selectPlaceholder: 'Silakan pilih',
        noAuths: "Tidak ada izin, silakan hubungi administrator",
        operationSuccess: "Operasi Berhasil",
        total: "Total",
        totalNum: "baris",
        dan: "Tunggal",
        shaung: "Ganda",
        pleaseSelectGroup: "Silakan pilih grup",
        preview: "Pratinjau",
        free: "Gratis",
        use: "Gunakan",
        dpi: 'Resolusi',
        delete: "Hapus",
        confirmDelete: "Yakin Menghapus",
        confirmDeleteSelectedTemplate: "Yakin menghapus template ini",
        push: "Terbitkan",
        pushConfirm: "Yakin menerbitkan ke template publik",
        pushRemovalConfirm: "Yakin menarik dari template publik",
        templateOrderRecord: "Riwayat Pesanan Template",
        unpublished: "Belum Diterbitkan",
        auditing: "Dalam Verifikasi",
        publishRejected: "Penerbitan Ditolak",
        publishSuccess: "Berhasil Diterbitkan",
        offShelf: "Tarik dari Pasar",
        公共模版: "Template Publik",
        我的模板: "Template Saya",
        共享记录: "Riwayat Berbagi",
        name: "Nama",
        pubdate: "Waktu Penerbitan",
        keySeachTip: "Silakan masukkan kata kunci",
        allGroup: "Semua Grup",
        add: "Tambah",
        edit: "Edit",
        programName: "Nama Program",
        selectGroup: "Pilih Grup",
    },
    checkManage: {
        total: "Total",
        totalNum: "baris",
        operationSuccess: "Operasi Berhasil",
        checkUserLogs: "Riwayat Verifikasi (Operator)",
        checkLogs: "Riwayat Verifikasi (Pemeriksa)",
        sourceCheck: "Verifikasi Materi",
        programCheck: "Verifikasi Program",
        checkAll: "Pilih Semua",
        auditPass: "Verifikasi Diterima",
        auditRefuse: "Verifikasi Ditolak",
        auditPass01: "Diterima",
        auditRefuse01: "Ditolak",
        auditRefuse02: "Tolak Verifikasi",
        auditor: "Pemeriksa",
        agentUserName: "Penerbit",
        interrogationTime: "Waktu Pengajuan Verifikasi",
        checkTime: "Waktu Verifikasi",
        checkName: "Nama Verifikasi",
        checkType: "Kategori Verifikasi",
        checkIp: "Alamat IP Pengajuan Verifikasi",
        checkReason: "Pesan",
        checkStatus: "Konten Operasi",
        rangePicker: "Tanggal Verifikasi",
        keyWord: "Kata Kunci",
        all: "Semua",
        program: 'Program',
        material: 'Materi',
        dan: "Tunggal",
        shaung: "Ganda",
        pleaseSelectProgram: "Silakan pilih program!",
        pleaseSelectMaterial: "Silakan pilih materi！",
        preview: "Pratinjau",
        dpi: 'Resolusi',
        auditRefuseTip: "Silakan masukkan alasan penolakan",
        unreviewed: "Belum Diverifikasi",
        notPassed: "Tidak Diterima",
        notUsed: "Belum Digunakan",
        edit: "Edit",
        none: "Tidak Ada",
        name: "Nama",
        size: "Ukuran",
        type: "Tipe",
        uploadTime: "Waktu Unggah",
        uploadUser: "Pengunggah",
        checkUser: "Pemeriksa",
        image: "Gambar",
        music: "Musik",
        video: "Video",
    },
    systemSet: {
        total: "Total",
        totalNum: "baris",
        inputPlaceholder: 'Silakan masukkan',
        selectPlaceholder: 'Silakan pilih',
        userList: "Anggota Organisasi",
        roleList: "Izin Peran",
        department: "Arsitektur Organisasi",
        diskInfo: "Ruang Penyimpanan",
        approveSet: "Persetujuan Konten",
        logList: "Manajemen Log",
        name: "Nama",
        account: "Akun",
        userName: "Nama Pengguna",
        phoneNumber: "Nomor Telepon",
        role: "Peran",
        createTime: "Waktu Pembuatan",
        operation: "Operasi",
        edit: "Edit",
        delete: "Hapus",
        addNew: "Tambah Baru",
        add: "Tambah",
        resetPassword: "Atur Ulang Kata Sandi",
        confirmDelete: "Yakin Menghapus",
        departmentOrganization: "Departemen Instansi",
        addNewUser: "Tambah Pengguna Baru",
        pleaseEnterUserName: "Silakan masukkan nama pengguna",
        confirmPasswordNotMatch: "Konfirmasi kata sandi tidak cocok dengan kata sandi yang dimasukkan!",
        operationSuccess: "Operasi Berhasil！",
        userNickname: "Nama Pengguna",
        pleaseEnterUserNickname: "Silakan masukkan nama pengguna",
        userNicknameRequired: "Nama pengguna tidak boleh kosong！",
        password: "Kata Sandi",
        pleaseEnterPassword: "Silakan masukkan kata sandi",
        passwordRequired: "Kata sandi tidak boleh kosong！",
        passwordTip: "Keamanan kata sandi Anda terlalu rendah (kata sandi harus mengandung 3 jenis apapun di antara huruf besar, huruf kecil, angka, dan karakter khusus dan panjangnya 8",
        confirmPassword: "Konfirmasi Kata Sandi",
        pleaseEnterPhoneNumber: "Silakan masukkan nomor telepon",
        phoneNumberRequired: "Nomor telepon tidak boleh kosong！",
        phoneNumberFormatError: "Silakan masukkan nomor telepon yang benar！",
        roleRequired: "Peran tidak boleh kosong！",
        required: "Tidak boleh kosong！",
        departmentName: "Departemen",
        modifyPassword: "Ubah Kata Sandi",
        newPassword: "Kata Sandi Baru",
        pleaseEnterNewPassword: "Silakan masukkan kata sandi baru",
        pwdMessage: "Panjang kata sandi 8~20 karakter, tidak boleh berisi spasi dan harus mengandung 3 jenis di antara huruf besar, huruf kecil, angka, dan karakter khusus",
        all: "Semua",
        noAuths: "Tidak ada izin, silakan hubungi administrator",
        departmentName01: "Nama Departemen",
        image: "Gambar",
        music: "Musik",
        video: "Video",
        buySize: "Jumlah Pembelian",
        totalMoney: "Jumlah Pembayaran",
        buycreateTime: "Waktu Pembelian",
        endTime: "Waktu Berakhir",
        buyTypeStr: "Tipe Pesanan",
        sourceCheck: "Verifikasi Materi",
        programCheck: "Verifikasi Program",
        programName: "Nama Program",
        diskExpansion: "Disarankan untuk membersihkan materi kedaluwarsa/tidak terpakai secara teratur selama penggunaan untuk memastikan kapasitas yang tersedia sistem. Jika Anda memerlukan ruang yang lebih besar, Anda dapat menghubungi pemasok perangkat Anda untuk mendapatkan layanan perluasan kapasitas ruang penyimpanan cloud. Layanan ini mungkin menimbulkan biaya, silakan merujuk pada informasi distributor untuk detailnya.",
        selectPermission: "Silakan pilih izin",
        checkPermission: "Silakan centang izin",
        addRole: "Tambah Peran",
        enterRoleName: "Silakan masukkan nama peran",
        roleName: "Nama Peran",
        roleNameRequired: "Nama peran tidak boleh kosong！",
        remark: "Catatan",
        enterRemark: "Silakan masukkan catatan",
        permissionSetting: "Pengaturan Izin",
        deleteSuccess: "Berhasil Dihapus！",
        confirmToDelete: "Yakin Menghapus？",
        orgName: "Nama Instansi",
        orgNameRequired: "Nama instansi tidak boleh kosong！",
        orgRemark: "Catatan Instansi",
        enterOrgRemark: "Silakan masukkan catatan instansi",
        capacityUsage: "Status Penggunaan Kapasitas",
        usedCapacity: "Kapasitas Terpakai",
        totalCapacity: "Total Kapasitas",
        remainingCapacity: "Kapasitas Sisa",
        capacityExpansion: "Perluasan Kapasitas",
        enable: "Aktifkan",
        disable: "Nonaktifkan",
        userName01: "Nama Pengguna",
        loginTime: "Waktu Login",
        ipAddress: "Alamat IP",
        loginResult: "Hasil Login",
        selectDate: "Pilih Tanggal",
        enterDate: "Silakan pilih tanggal",
        selectStartTime: "Silakan pilih waktu mulai",
        selectEndTime: "Silakan pilih waktu akhir",
        enterUserName: "Silakan masukkan nama pengguna",
        userCount: "Jumlah Pengguna",
        roleDesc: "Deskripsi Peran",
        roleAuthorization: "Otorisasi Peran",
        success: "Berhasil",
        failure: "Gagal",
        time: "Waktu",
        operationContent: "Konten Operasi",
        playCount: "Jumlah Pemutaran",
        playDuration: "Durasi Pemutaran",
        selectDevice: "Pilih Perangkat",
        enterProgramName: "Silakan masukkan nama program",
        serialNumber: "Nomor Urut",
        publishContentName: "Nama Konten yang Diterbitkan",
        playMode: "Cara Pemutaran",
        cyclePlay: "Putar Berulang",
        insertPlay: "Sisip Pemutaran",
        paddingPlay: "Pemutaran Pengisi",
        playDeviceId: "ID Perangkat Pemutar",
        playDeviceName: "Nama Perangkat Pemutar",
        publishTime: "Waktu Penerbitan",
        downloadStatus: "Status Unduhan",
        notDownloaded: "Belum Diunduh",
        downloading: "Mengunduh",
        downloadSucceeded: "Berhasil Diunduh",
        downloadFailed: "Gagal Diunduh",
        enterPublishContentName: "Silakan masukkan nama konten yang diterbitkan",
        terminalId: "ID Terminal",
        belongOrg: "Instansi Terkait",
        reportTime: "Waktu Pelaporan",
        reportIp: "IP Pelaporan",
        logInfo: "Informasi Log",
        details: "Detail",
        confirmDeletion: "Yakin akan menghapus？",
        logDetails: "Detail Log",
        download: "Unduh",
        deptOrg: "Departemen Instansi",
        query: "Cari",
        queryByTerminalId: "Cari berdasarkan ID Terminal",
        batchDeleteLogs: "Hapus Log Secara Batch",
        customTimeDeleteLogs: "Hapus Log pada Waktu Kustom",
        selectTimeRangeFirst: "Silakan pilih rentang waktu terlebih dahulu",
        deleteAllDeviceLogsIfEmpty: "Jika ID perangkat tidak diisi, secara default akan menghapus log semua perangkat",
        enterDeviceIdToDeleteLogs: "Silakan masukkan ID perangkat yang lognya akan dihapus",
        confirmDeleteAction: "Yakin Menghapus",
        selectDeleteRangeFirst: "Silakan pilih rentang penghapusan terlebih dahulu",
        networkConnectionFailed: "Koneksi Jaringan Gagal",
        playLog: "Log Pemutaran",
        publishLog: "Log Penerbitan",
        errorLog: "Log Kesalahan",
        operationLog: "Log Operasi",
        fileLog: "Log File",
        userOperateLog: "Log Login",
    },
    userManual: {
        userManual: "Panduan Pengguna",
        noData: "Tidak Ada Data",
    },
    systemNotice: {
        systemNotice: "Pemberitahuan Sistem",
        noData: "Tidak Ada Data",
        total: "Total",
        totalNum: "baris",
        "markAllRead": "Semua Sudah Dibaca",
        "deleteAll": "Hapus Semua",
        "all": "Semua",
        "unread": "Belum Dibaca",
        "read": "Sudah Dibaca",
        "type": "Tipe",
        "content": "Konten",
        "date": "Tanggal",
        "status": "Status",
        "confirmDelete": "Yakin Menghapus？",
        "confirm": "Ya",
        "cancel": "Batal",
        "delete": "Hapus"
    }
};